import CATEGORIES from "../data/categories";
import { useApp } from "../context/AppContext";

export default function CategoryNav() {
  const { page, activeCat, navigate, setSearch } = useApp();

  const handleCategoryClick = (catId) => {
    setSearch("");           // clear any active search when picking a category
    navigate("products", catId);
  };

  return (
    <nav className="cat-nav">
      <div className="cat-nav-inner">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            className={`cat-btn ${
              page === "products" && activeCat === cat.id ? "active" : ""
            }`}
            onClick={() => handleCategoryClick(cat.id)}
          >
            <span className="cat-btn-icon">{cat.icon}</span>
            <span className="cat-btn-label">{cat.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
